import React from 'react';
import { DealerOverview } from 'site-modules/shared/components/inventory/contact-dealer/dealer-overview/dealer-overview';

export function TraditionalDealerOverview() {
  return (
    <DealerOverview className="border-top d-flex flex-column gap-0_5 mt-1_5 pt-1_5">
      <DealerOverview.FiveStar />
      <DealerOverview.Location icon="icon-location" />
      <DealerOverview.Delivery classes="size-16" />
      <DealerOverview.Phone useUnderlineLink />
    </DealerOverview>
  );
}
